import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { http, apiError } from "../../lib/api";
import { useAuth } from "../../lib/auth";

export const DigestPrefs = () => {
  const { user } = useAuth();
  const [p, setP] = useState(null);
  const [busy, setBusy] = useState("");
  useEffect(() => {
    http.get("/admin/inquiries/digest/preferences").then(({ data }) => setP(data)).catch(() => setP({ digest_enabled: true, digest_consolidated: false }));
  }, []);
  const save = async (next) => {
    setP(next);
    setBusy("save");
    try {
      const { data } = await http.put("/admin/inquiries/digest/preferences", next);
      setP(data);
      toast.success("Digest preferences saved");
    } catch (e) {
      toast.error(apiError(e));
    } finally {
      setBusy("");
    }
  };
  const sendNow = async () => {
    setBusy("send");
    try {
      await http.post("/admin/inquiries/digest/send-me");
      toast.success(`Digest sent to ${user?.email}`);
    } catch (e) {
      toast.error(apiError(e));
    } finally {
      setBusy("");
    }
  };
  if (!p) return null;
  return (
    <section className="border hairline p-6 bg-[var(--ink-2)] space-y-4" data-testid="digest-prefs">
      <p className="eyebrow">Daily follow-up digest</p>
      <p className="text-xs text-slate-400">Emailed every morning at 8:00 AM Central Time to {user?.email}. Skipped on days with nothing to report.</p>
      <label className="flex items-center justify-between gap-3 cursor-pointer">
        <span className="text-sm text-slate-100">Receive the daily digest</span>
        <input type="checkbox" className="w-5 h-5 accent-[#d4af37]" checked={p.digest_enabled} onChange={(e) => save({ ...p, digest_enabled: e.target.checked })} data-testid="digest-enabled-checkbox" />
      </label>
      {user?.role === "owner" && (
        <label className="flex items-center justify-between gap-3 cursor-pointer">
          <span className="text-sm"><span className="block text-slate-100">Consolidated team overview</span><span className="text-xs text-slate-400">Include inquiries assigned to everyone, plus unassigned ones</span></span>
          <input type="checkbox" className="w-5 h-5 accent-[#d4af37]" checked={p.digest_consolidated} onChange={(e) => save({ ...p, digest_consolidated: e.target.checked })} data-testid="digest-consolidated-checkbox" />
        </label>
      )}
      <button className="btn-ghost !py-2.5 !text-xs" onClick={sendNow} disabled={!!busy} data-testid="digest-send-now">{busy === "send" && <Loader2 className="w-3 h-3 animate-spin" />} Email me today's digest now</button>
    </section>
  );
};
